import { getItem } from './storage';
import { convertLegacyCookieToJwt } from '../api/legacySessions';
import { updateSession } from '../api/sessions';
import { safeParseJwtPayload } from './jwt';

export const cookieToJwtExchange = async () => {
  try {
    if (getItem('coreApiAccessToken')) return;

    const exchangeRes = await convertLegacyCookieToJwt();
    if (exchangeRes.error || !exchangeRes.data?.data) {
      throw new Error('Failed to exchange the cookie to jwt refresh token');
    }
    const refreshToken = exchangeRes.data.data.refreshToken;
    const jwtRaw = safeParseJwtPayload(refreshToken);
    if (!jwtRaw) {
      throw new Error('Failed to parse jwt payload');
    }

    await updateSession({ sessionId: jwtRaw.sessionId, refreshToken });
  } catch (error) {
    console.error(error);
  }
};
